import React, { useMemo, useState } from 'react';
import { marketCountries } from '../data/siteData';

const origin = { x: 57, y: 43 };

const curvePath = (country) => {
  const controlX = (origin.x + country.x) / 2;
  const controlY = Math.min(origin.y, country.y) - 13;
  return `M ${origin.x} ${origin.y} Q ${controlX} ${controlY} ${country.x} ${country.y}`;
};

const InteractiveMarketMap = () => {
  const [activeId, setActiveId] = useState(marketCountries[0].id);
  const activeCountry = useMemo(
    () => marketCountries.find((country) => country.id === activeId) || marketCountries[0],
    [activeId]
  );

  return (
    <div className="market-map-experience">
      <div className="interactive-map-stage" aria-label="Interactive export market map">
        <div className="map-coordinate-grid" aria-hidden="true"></div>

        <svg className="trade-route-svg" viewBox="0 0 100 60" preserveAspectRatio="none" aria-hidden="true">
          {marketCountries.map((country) => (
            <path
              key={country.id}
              d={curvePath(country)}
              className={`trade-route-path ${activeCountry.id === country.id ? 'trade-route-path-active' : ''}`}
            />
          ))}
        </svg>

        <span className="map-hub" style={{ '--x': `${origin.x}%`, '--y': `${origin.y}%` }}>
          <strong>India</strong>
          <small>Export origin</small>
        </span>

        {marketCountries.map((country) => (
          <button
            key={country.id}
            type="button"
            className={`map-pin ${activeCountry.id === country.id ? 'map-pin-active' : ''}`}
            style={{ '--x': `${country.x}%`, '--y': `${country.y}%` }}
            onClick={() => setActiveId(country.id)}
            aria-pressed={activeCountry.id === country.id}
            aria-label={`Show ${country.country} market details`}
          >
            <span>{country.country}</span>
          </button>
        ))}

        <article className="active-market-card">
          <img src={activeCountry.image} alt={`${activeCountry.city}, ${activeCountry.country} market view`} />
          <div>
            <span>{activeCountry.region}</span>
            <h2>{activeCountry.country}</h2>
            <p>{activeCountry.summary}</p>
          </div>
        </article>
      </div>

      <div className="country-image-rail" aria-label="Country market selectors">
        {marketCountries.map((country) => (
          <button
            key={country.id}
            type="button"
            className={`country-image-card ${activeCountry.id === country.id ? 'country-image-card-active' : ''}`}
            onClick={() => setActiveId(country.id)}
            aria-pressed={activeCountry.id === country.id}
          >
            <img src={country.image} alt={`${country.city}, ${country.country}`} />
            <span>{country.region}</span>
            <strong>{country.country}</strong>
            <small>{country.focus.join(' / ')}</small>
          </button>
        ))}
      </div>
    </div>
  );
};

export default InteractiveMarketMap;
